import React from 'react'
import { Row, Card } from 'antd'
import DeserveStyle from '../../styles/CUREHackathon.module.css'
import { SEO } from './components'

const CUREHackathon = () => {
  return (
    <>
      <SEO
        title={"CURE Hackathon 2025 "} 
        description={"CURE Hackathon 2025 fostered collaboration, creative problem-solving, and reinforced CURE’s commitment to innovation and continuous improvement."} 
        url={"/nm/news/cure-hackathon"}
      />
      <div className={`${DeserveStyle["drive-deserve-transparency-screen"]}`}>
        <Row justify="center">
          <Card className={`${DeserveStyle["drive-deserve-card"]}`}>
            <article>
              <h1 className={`${DeserveStyle["drive-deserve-title"]}`}>
                CURE Hackathon 2025 - Where Your Insights Shape Your Innovation
              </h1>
              <p className={`${DeserveStyle["drive-deserve-author-name"]}`}>Princeton, NJ - March 13, 2025 </p>
              
              <p style={{textAlign:"left"}}>
              CURE, CIO and Head of Digital Transformation Doug Benalan, recently led the first in a series of interactive events - 
              the initial entitled: &quot;CURE Hackathon 2025: Where Your Insights Shape the Innovation.&quot; The successful gathering provided 
              a platform for Technology, UX, and Operations teams to collaborate, brainstorm, and propose innovative recommendations to
              enhance the CURE Quoting Project.
              </p>

              <p style={{textAlign:"left"}}>
              According to Doug, "the insights gained during the Hackathon will be instrumental in shaping a more effective and user-friendly product development strategy." 
              To gauge the event&apos;s impact, an anonymous survey was conducted, revealing overwhelmingly positive feedback. Employees walked away highly enthusiastic,
              highlighting it as a valuable opportunity for collaboration and innovation. In fact, the participants are already looking forward to the next Hackathon.
              </p>

              <p style={{textAlign:"left"}}>
              This event was a collective effort, with the support of the technology team and Nancy Waddle, chief of staff, playing a 
              key role in organizing the operations team, Kelli HR director managing logistics, and Kelly Kemp, associate director of UX, 
              helping to evaluate and finalize the winners. Their contributions ensured a seamless and engaging experience for all involved.
              </p>

              <p style={{textAlign:"left"}}>
              Overall, the CURE Hackathon 2025 successfully fostered cross-functional collaboration, encouraged creative problem-solving,
              and reinforced the company's commitment to innovation and continuous improvement.
              </p>

            </article>
          </Card>
        </Row>
      </div>
    </>
  )
}

export default CUREHackathon
